import AttributeType from './AttributeType'

export default AttributeType
